export const AI_NOTES_GA_EVENT = {
  GENERATED: 'ai_notes_generated',
  IMPROVE_REQUESTED: 'ai_notes_improve_requested',
  ACCEPTED: 'ai_notes_accepted',
};

export const AI_CHECKER_GA_EVENT = {
  AI_CHECKER_TRIGGER: 'ai_checker_triggered',
  AI_CHECKER_REPORT_GENERATED: 'ai_checker_report_generated',
  AI_CHECKER_REPORT_VIEW: 'ai_checker_report_view',
  AI_CHECKER_FEEDBACK: 'ai_checker_feedback',
  AI_CHECKER_REPORT_EDIT: 'ai_checker_report_edit',
};
